// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-13eacffb] .empty-content__icon span{background-size:64px;width:64px;height:64px}", "",{"version":3,"sources":["webpack://./src/views/ActivityTab.vue"],"names":[],"mappings":"AACA,4CACC,oBAAA,CACA,UAAA,CACA,WAAA","sourcesContent":["\n::v-deep .empty-content__icon span {\n\tbackground-size: 64px;\n\twidth: 64px;\n\theight: 64px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
